import React, { useState , useContext } from 'react'
import LineUpAllAway from './LineUpAllAway'
import LineUpAllHome from './LineUpAllHome'
import LineUp from './LineUp'
import KadroAll from './KadroAll'


export default function Team() {

  return (
    <div className='TeamsContainer'>
      <LineUp/>
      <KadroAll/>
    </div>
  )
}
